// import { getTagIdsFromString } from '@cpsy-rmap-project/web-core/crossref'

export const getAutoTags = async (_str: string) => {
  // strにアブストデータが入っています（crossrefで取ってきたabstもしくはSSのAPIで取れたabstが入っています）

  // NOTE: 仮で作った愚直タグ検索機能（文字列一致のみの検索）を通してタグデータを取得しています。
  // const autoTagData = await getTagIdsFromString(str) // 簡易自動タグ付け

  // タグ付けは無し
  const autoTagData = {
    rdocConstructs: [],
    unitOfAnalysis: [],
    dsm5: [],
    compMathMethodExperimentalDesign: [],
    compMathMethodDataType: [],
    compMathMethodModels: [],
    symptomatology: []
  }

  // ヒント
  // getSemanticScholarAbstractなどを参考にすると、APIに対して情報をとってくるなどでTagの反映ができる
  // const autoTagData = await (await fetch('https://tag-api-auto.hogehoge.com')).json() as { [x in TagAxisId]: string[] }
  // などをして情報を取ってくるイメージ

  // 最終的にはautoTagDataが下のようなJsonな形式になっていればOKです
  // {
  //   rdocConstructs: ['TagnoIDtoka1111', 'HokanoTagID2222'],
  //   unitOfAnalysis: ['TagnoIDtoka3333', 'HokanoTagID4444'],
  //   ...etc
  // }

  return autoTagData
}
